import { render, staticRenderFns } from "./priceListConfigEditor.vue?vue&type=template&id=360bd37b&scoped=true&"
import script from "./priceListConfigEditor.vue?vue&type=script&lang=js&"
export * from "./priceListConfigEditor.vue?vue&type=script&lang=js&"
import style0 from "./priceListConfigEditor.vue?vue&type=style&index=0&id=360bd37b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360bd37b",
  null
  
)

export default component.exports